var map = {
	"./404.jpg": "a8f07",
	"./account-img.png": "aca0",
	"./error-general.png": "a931",
	"./error.png": "b948",
	"./hot-bg.png": "4e47",
	"./icon-result.png": "5868",
	"./icon.png": "f0fc",
	"./icon2.png": "e82b",
	"./investor.png": "e7ca",
	"./logo.png": "4ffd",
	"./new-bg.png": "73ac",
	"./no-funds.png": "31ea",
	"./ocrback.png": "e53c",
	"./ocrback_ok.png": "f546",
	"./ocrover.png": "7f11",
	"./ocrover_ok.png": "6ca6",
	"./ocroverother.png": "b1b6",
	"./ocroverother_ok.png": "14a8",
	"./org.png": "e738",
	"./other.png": "01ac",
	"./pro.png": "011c",
	"./qq_icon.png": "4e85",
	"./sfz.png": "37ad",
	"./top1.png": "071b",
	"./top2.png": "c300",
	"./top3.png": "4d59",
	"./white-bg.png": "f384",
	"./yingyezhizhao.jpeg": "e2cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";